import { render, staticRenderFns } from "./SaveLoadFieldsModal.vue?vue&type=template&id=687d8336&scoped=true"
import script from "./SaveLoadFieldsModal.vue?vue&type=script&lang=js"
export * from "./SaveLoadFieldsModal.vue?vue&type=script&lang=js"
import style0 from "./SaveLoadFieldsModal.vue?vue&type=style&index=0&id=687d8336&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../ChatGenial-hom-sync/client/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687d8336",
  null
  
)

export default component.exports